function formatDoubleWithCommas(double: number | string, decimals = 2) {
  const num = Number(double);

  if (!Number.isFinite(num)) return double.toString();

  // Comma-separate the whole part only. Running the regex over the full string
  // would also group the fraction, e.g. "1234.5678" -> "1,234.5,678".
  const [whole, fraction] = num.toFixed(decimals).split(".");
  const groupedWhole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return fraction ? `${groupedWhole}.${fraction}` : groupedWhole;
}

export default formatDoubleWithCommas;
